import { render, staticRenderFns } from "./CreateStagingModal.vue?vue&type=template&id=8cfab106&scoped=true"
import script from "./CreateStagingModal.vue?vue&type=script&lang=js"
export * from "./CreateStagingModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=8cfab106&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfab106",
  null
  
)

export default component.exports